import { createService } from "~/hocs/crud";
import * as model from "./model";

const getQueryExtractionGuid = (record) => {
    return {
        queryId: record.queryId,
    };
};

export const MODEL_NAME = "queryExtractionSetup";
export const REQUEST_PAYLOAD_FILTER = "queryExtractionFilter";
export const REQUEST_PAYLOAD_SORT_LIST = "queryExtractionSortList";
export const REQUEST_PAYLOAD_PAGE_OPTIONS = "queryExtractionPageOptions";

export const defaultRequestFilters = {
    [REQUEST_PAYLOAD_FILTER]: {
        queryId: "",
        name: "",
        description: "",
        lastModified: "",
    },
    [REQUEST_PAYLOAD_SORT_LIST]: [
        {
            Sort: {
                Direction: "ASC",
                Order: 0,
            },
        },
    ],
    [REQUEST_PAYLOAD_PAGE_OPTIONS]: {
        pageSize: 50,
        skip: 0,
    },
};

export const defaultSort = {
    FieldName: "QueryId",
    ...defaultRequestFilters[REQUEST_PAYLOAD_SORT_LIST][0],
};

export const service = createService({
    guid: model.PROPS_QUERY_ID,
    id: "queryExtraction",
    recordName: "queryId",
    model: MODEL_NAME,
    defaultRequestFilters,
    REQUEST_PAYLOAD_FILTER,
    REQUEST_PAYLOAD_SORT_LIST,
    REQUEST_PAYLOAD_PAGE_OPTIONS,
    _defaultLabels: {
        [model.PROPS_CAN_DELETE]: {
            visible: false,
            label: "canDelete",
            gridCol: 5,
            className: "col-shift-15",
        },
        [model.PROPS_QUERY_ID]: {
            label: "queryId",
            gridCol: 10,
            sortable: true,
        },
        [model.PROPS_NAME]: {
            label: "name",
            gridCol: 25,
            sortable: true,
        },
        [model.PROPS_DESCRIPTION]: {
            label: "description",
            gridCol: 30,
            sortable: true,
        },
        [model.PROPS_LAST_MODIFIED]: {
            label: "lastModified",
            gridCol: 20,
            sortable: true,
        },
    },
    getGuid: getQueryExtractionGuid,
    defaultSort: {
        FieldName: "QueryId",
        Sort: {
            Direction: "ASC",
            Order: 0,
        },
    },
});
